import { createMetadataGenerator } from './generateMetadata';
export type { LocalizedSlugs, MetadataOptions } from './generateMetadata';

// Default Roblox description
const ROBLOX_DEFAULT_DESCRIPTION =
  'Roblox is a global platform where millions of people gather together every day to imagine, create, and share experiences with each other in immersive, user-generated 3D worlds.';

// Factory function to create app-specific metadata generator
export function createRobloxMetadataGenerator(
  siteUrl: string,
  languageTags: Record<string, string>
) {
  return createMetadataGenerator({
    siteName: 'Roblox',
    siteUrl,
    defaultDescription: ROBLOX_DEFAULT_DESCRIPTION,
    languageTags,
  });
}
